import { useTranslation } from "react-i18next";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { SegmentedFilter } from "@/components/ui/segmented-filter";
import type { AssignmentStatus } from "@/types/test";

interface Props {
  status: AssignmentStatus | "all";
  search: string;
  onStatusChange: (s: AssignmentStatus | "all") => void;
  onSearchChange: (s: string) => void;
}

const OPTIONS: (AssignmentStatus | "all")[] = ["all", "active", "submitted", "expired"];

export function AssignmentFilters({ status, search, onStatusChange, onSearchChange }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-2.5">
      <div className="relative w-full sm:w-64">
        <MagnifyingGlass
          aria-hidden
          className="pointer-events-none absolute inset-y-0 left-3 my-auto size-4 text-muted-foreground"
        />
        <Input
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={t("tests.therapist.searchPlaceholder")}
          className="h-10 rounded-xl pl-9"
        />
      </div>
      <SegmentedFilter
        ariaLabel="status"
        options={OPTIONS.map((opt) => ({
          value: opt,
          label: t(`tests.therapist.statusFilters.${opt}`),
        }))}
        value={status}
        onChange={onStatusChange}
      />
    </div>
  );
}
